var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 87,
    viewBox: "0 0 88 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.8101,
    cy: 43.5,
    r: 43.5,
    fill: "#EDEFF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1028_6108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.504 42.1134C46.3443 42.1134 48.8035 41.0672 50.8134 39.0029C52.8226 36.939 53.8417 34.4137 53.8417 31.4963C53.8417 28.5799 52.823 26.0542 50.8131 23.9897C48.8032 21.9261 46.344 20.8799 43.504 20.8799C40.6633 20.8799 38.2045 21.9261 36.1949 23.99C34.1853 26.0539 33.1663 28.5795 33.1663 31.4963C33.1663 34.4137 34.1853 36.9394 36.1949 39.0033C38.2051 41.0668 40.6643 42.1134 43.504 42.1134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5924 54.7748C61.5345 53.9159 61.4172 52.979 61.2447 51.9896C61.0705 50.9928 60.8462 50.0504 60.5777 49.1892C60.3 48.299 59.9231 47.4199 59.4565 46.5774C58.9728 45.7031 58.4043 44.9417 57.7665 44.3151C57.0994 43.6597 56.2828 43.1327 55.3384 42.7483C54.3973 42.3659 53.3544 42.1722 52.2387 42.1722C51.8006 42.1722 51.3769 42.3568 50.5586 42.904C50.0549 43.2413 49.4658 43.6314 48.8083 44.0629C48.2461 44.4308 47.4844 44.7755 46.5436 45.0876C45.6258 45.3926 44.6939 45.5473 43.7737 45.5473C42.8542 45.5473 41.9223 45.3926 41.0038 45.0876C40.064 44.7759 39.302 44.4312 38.7408 44.0632C38.0895 43.6358 37.5 43.2457 36.9889 42.9037C36.1712 42.3565 35.7475 42.1719 35.3094 42.1719C34.1934 42.1719 33.1508 42.3659 32.21 42.7486C31.2663 43.1324 30.4493 43.6593 29.7816 44.3155C29.1437 44.9423 28.5753 45.7034 28.092 46.5774C27.626 47.4199 27.2488 48.2986 26.9711 49.1895C26.7029 50.0508 26.4786 50.9928 26.3044 51.9896C26.1315 52.9776 26.0146 53.9149 25.9566 54.7758C25.8997 55.6176 25.8708 56.4937 25.8708 57.3788C25.8708 59.6798 26.5831 61.5426 27.9875 62.9164C29.3746 64.272 31.2097 64.9594 33.4419 64.9594H54.1082C56.3398 64.9594 58.1748 64.272 59.5622 62.9164C60.967 61.5436 61.6792 59.6801 61.6792 57.3785C61.6789 56.4903 61.6497 55.6142 61.5924 54.7748Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1028_6108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.92,
    height: 44.08,
    fill: "white",
    transform: "translate(22.3501 20.8799)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.24f64cb34119f6b8ebe19eb7cbd7b83d.svg";
export { ForwardRef as ReactComponent };